module.exports = __webpack_public_path__ + "static/media/star-solid.290a50ca.svg";